import { type ReactNode, useCallback, useState } from 'react';
import { useToggle } from '@direct-frontend/stdlib';
import { deleteConstructorTemplate, getConstructorPagesSettings } from '../model/slices';
import { useChangeConstructorRightBarSection } from './useChangeConstructorRightBarSection';

export const useConstructorDeleteTemplate = ({
    renderDeleteTemplateModal,
}: {
    renderDeleteTemplateModal: (props: {
        isOpen: boolean;
        onClose: VoidFunction;
        onDelete: VoidFunction;
        templateId: string;
    }) => ReactNode;
}) => {
    const { value: isOpen, toggleOn: open, toggleOff: close } = useToggle();
    const [templateId, setTemplateId] = useState('');

    const changeConstructorRightBarSection = useChangeConstructorRightBarSection();
    const deleteTemplate = useCallback(
        (templateId: string) => {
            const pages = getConstructorPagesSettings();

            const pagesWithTemplate = Object.values(pages).filter((page) =>
                page.layout.some((section) => section.template_id === templateId)
            );

            if (pagesWithTemplate.length) {
                setTemplateId(templateId);
                open();
            } else {
                deleteConstructorTemplate(templateId);
                changeConstructorRightBarSection();
            }
        },
        [open, changeConstructorRightBarSection]
    );

    const onClose = useCallback(() => {
        setTemplateId('');
        close();
    }, [close]);

    return {
        deleteTemplate,
        renderConfirmDeleteTemplateModal: () =>
            renderDeleteTemplateModal({
                isOpen,
                onClose: onClose,
                onDelete: () => {
                    deleteConstructorTemplate(templateId);
                    changeConstructorRightBarSection();
                    onClose();
                },
                templateId,
            }),
    };
};
